import { render, staticRenderFns } from "./intelligencePost.vue?vue&type=template&id=a4d38a06&scoped=true&"
import script from "./intelligencePost.vue?vue&type=script&lang=js&"
export * from "./intelligencePost.vue?vue&type=script&lang=js&"
import style0 from "./intelligencePost.vue?vue&type=style&index=0&id=a4d38a06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d38a06",
  null
  
)

export default component.exports